export default "__VITE_ASSET__WIzigSrT__"